<template>
  <div>
    <h2>{{ $t("account.my_account") }}</h2>
    <a
    v-if="router_name=='account'"
      class="logout"
      href="javascript:;"
      onclick="event.preventDefault();
        document.getElementById('logout_form').submit();localStorage.removeItem('isLogin')"
    >
      {{ $t("account.log_out") }}
    </a>
    <form
      id="logout_form"
      action="/logout"
      method="POST"
      style="display: none"
    ></form>
  </div>
</template>
<script>
export default {
  props: ["router_name"],
  mounted(){
      console.log(111,this.router_name);
  }
};
</script>
<style scoped lang='scss'>
h2 {
  margin-top: 16px;
}
.logout {
  font-size: 14px;
  display: block;
  color: black;
  text-decoration: none;
}
</style>